import "core-js/modules/es.regexp.exec";

/**
 * 推荐使用方式：
import OpenApp from '@tencent/vft-common/openapp/index';

async function openView(schemaUrl) {
  // 微信手Q腾讯视频APP腾讯新闻天天快报APP内canGetInstallState为true，其他情况下canGetInstallState为false，走的是browser拉起APP的方式。
  if (OpenApp.canGetInstallState) {
    // 判断是否安装腾讯视频APP
    if (await OpenApp.getInstallState()) {
      // 安装则拉起
      let res = await OpenApp.launch(schemaUrl);
      console.log(res);
    } else {
      // 没有安装则跳转到应用宝下载地址或直接下载(腾讯新闻天天快报内)
      OpenApp.download();
    }
  } else {
    // browser环境下直接尝试拉起APP
    if (await OpenApp.launch(schemaUrl)) {
      // 有安装
    } else {
      // 无安装
    }
  }
}
*/
import wechat from './wechat';
import qq from './qq';
import qqnews from './qqnews';
import tenvideo from './tenvideo';
import browser from './browser';

var _openapp;

var result = /MicroMessenger|QQLiveBrowser|qqvideobrower|QQ\/|qqnews|qnreading/gi.exec(navigator.userAgent);

if (result) {
  switch (result[0].toLowerCase()) {
    case 'micromessenger':
      _openapp = wechat;
      break;

    case 'qqlivebrowser':
    case 'qqvideobrower':
      _openapp = tenvideo;
      break;

    case 'qq/':
      _openapp = qq;
      break;

    case 'qqnews':
    case 'qnreading':
      _openapp = qqnews;
      break;

    default:
      _openapp = browser;
      break;
  }
} else {
  _openapp = browser;
}

var openapp = _openapp;
export default openapp;